import { default as indexBpcBF3ZayKMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/buyer/register/[esgDataInvitationId]/index.vue?macro=true";
import { default as commonzszwsVo6qyMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/guest/upload/common.vue?macro=true";
import { default as verifyA7iQg2VfG4Meta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/guest/upload/verify.vue?macro=true";
import { default as indexjisZXFHj6YMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/index.vue?macro=true";
import { default as _91id_93sg62w3mQesMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/answer-and-evaluation/evaluation-detail/[id].vue?macro=true";
import { default as _91id_93fhpKLDUomGMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/answer-and-evaluation/evaluation-detail/buyer/[id].vue?macro=true";
import { default as indexvpo1ogwr2eMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/answer-and-evaluation/index.vue?macro=true";
import { default as emailWhE3jS3LpbMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/buyer/[supplierRegistTemplateId]/email.vue?macro=true";
import { default as indexHWOFN1NaoGMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/buyer/[supplierRegistTemplateId]/index.vue?macro=true";
import { default as indextXAXIfGeK4Meta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/buyer/[supplierRegistTemplateId]/new/index.vue?macro=true";
import { default as buyerlisttMOwyoUqQXMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/buyerlist.vue?macro=true";
import { default as indexIHPJc7RTDeMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/companies/[companyId]/users/[userId]/edit/index.vue?macro=true";
import { default as indexuBpO210oM1Meta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/companies/[companyId]/users/create/index.vue?macro=true";
import { default as company7lXqIdYItdMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/datashare/company.vue?macro=true";
import { default as detailgGiBoCAawlMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/datashare/detail.vue?macro=true";
import { default as indexPd4MOgAIEPMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/datashare/index.vue?macro=true";
import { default as entryBmdePYNgOXMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/entry.vue?macro=true";
import { default as loginlXXViEg2u4Meta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/login.vue?macro=true";
import { default as editL3VxJyux4cMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/questiondetail/[id]/edit.vue?macro=true";
import { default as indexMloCRhozHxMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/questiondetail/[id]/index.vue?macro=true";
import { default as questionentryYnGDIpO2gAMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/questionentry.vue?macro=true";
import { default as questionslist2jqNutTamUMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/questionslist.vue?macro=true";
import { default as index3yTTPaDl1rMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/userdetail/[companyId]/index.vue?macro=true";
import { default as questionaddI3crPuhzaPMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/userdetail/[companyId]/questionadd.vue?macro=true";
import { default as _91supplierRegistTemplateId_931VplssFiAxMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/userdetail/[companyId]/report-generation/[supplierRegistTemplateId].vue?macro=true";
import { default as _91id_93N8soJ11dKAMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/useredit/[id].vue?macro=true";
import { default as userlisthZAhp2PCWIMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/userlist.vue?macro=true";
import { default as detailR6Ozkw0i7wMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/buyer/datashare/detail.vue?macro=true";
import { default as indexBVZv1d3LtcMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/buyer/datashare/index.vue?macro=true";
import { default as contactX4ulMiyUnSMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/contact.vue?macro=true";
import { default as dashboard5QndT6N0f0Meta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/dashboard.vue?macro=true";
import { default as companyRTDT9wWDdAMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/datashare/company.vue?macro=true";
import { default as detail0o8xIFkaBtMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/datashare/detail.vue?macro=true";
import { default as edituOarTdcl0nMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/datashare/edit.vue?macro=true";
import { default as indexSgQft1jPa9Meta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/datashare/index.vue?macro=true";
import { default as detail_45extraBXEjtaeRdZMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/detail-extra.vue?macro=true";
import { default as indexsnxNXnK5LUMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/evaluation/analysis/index.vue?macro=true";
import { default as indexVFaGcXljeWMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/evaluation/dashboard/index.vue?macro=true";
import { default as improvementplans0mh4yrrefeMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/evaluation/improvementplans.vue?macro=true";
import { default as detailmAM62vEyFaMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/improvementplans/detail.vue?macro=true";
import { default as indexN1KpmlY7cQMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/improvementplans/index.vue?macro=true";
import { default as login_45mfaA63ZaRc9mvMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/login-mfa.vue?macro=true";
import { default as loginiiF0XlPWIZMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/login.vue?macro=true";
import { default as logout5VnaPrLLoqMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/logout.vue?macro=true";
import { default as confirmwVacYnUyOKMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/[questionGroupId]/confirm.vue?macro=true";
import { default as edit0oTqwFY0NJMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/[questionGroupId]/edit.vue?macro=true";
import { default as indexjGGOhGFtNGMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/[questionGroupId]/index.vue?macro=true";
import { default as previewWr1Nm9W4F8Meta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/[questionGroupId]/preview.vue?macro=true";
import { default as _91questionGroupByCompanyId_93iHvKqRPBTAMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/answers/[questionGroupByCompanyId].vue?macro=true";
import { default as indexW2QpscD80JMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/answers/index.vue?macro=true";
import { default as indexpiA3aoTNKYMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/index.vue?macro=true";
import { default as newbN2uwnH2AHMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/new.vue?macro=true";
import { default as resetpasswordz0Bq4hrpekMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/resetpassword.vue?macro=true";
import { default as resetpasswordcompleteWccBJH9gcVMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/resetpasswordcomplete.vue?macro=true";
import { default as resetpasswordconfirm49Um8cJnRIMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/resetpasswordconfirm.vue?macro=true";
import { default as index1nPrZSA9dtMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/scorecard/detail/index.vue?macro=true";
import { default as preview7PyavizkuPMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/scorecard/detail/preview.vue?macro=true";
import { default as indexdG9WooZRu9Meta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/scorecard/index.vue?macro=true";
import { default as indexH2FrSDJUAOMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/settings/account/[userId]/edit/index.vue?macro=true";
import { default as indexSN8nPRRcvzMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/settings/account/create/index.vue?macro=true";
import { default as indexN5UnQqZ3GeMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/settings/account/index.vue?macro=true";
import { default as indexY9EM8rOKRkMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/upload/common/index.vue?macro=true";
import { default as _91temporaryUserId_93dgjgx8lbvaMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/supplier/register/[supplierRegistTemplateId]/[temporaryUserId].vue?macro=true";
import { default as index2Nbb5vFbHzMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/supplier/register/[supplierRegistTemplateId]/index.vue?macro=true";
import { default as index3aPxrNDkCfMeta } from "/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/users/create/[userId]/index.vue?macro=true";
export default [
  {
    name: indexBpcBF3ZayKMeta?.name ?? "buyer-register-esgDataInvitationId",
    path: indexBpcBF3ZayKMeta?.path ?? "/buyer/register/:esgDataInvitationId()",
    meta: indexBpcBF3ZayKMeta || {},
    alias: indexBpcBF3ZayKMeta?.alias || [],
    redirect: indexBpcBF3ZayKMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/buyer/register/[esgDataInvitationId]/index.vue").then(m => m.default || m)
  },
  {
    name: commonzszwsVo6qyMeta?.name ?? "guest-upload-common",
    path: commonzszwsVo6qyMeta?.path ?? "/guest/upload/common",
    meta: commonzszwsVo6qyMeta || {},
    alias: commonzszwsVo6qyMeta?.alias || [],
    redirect: commonzszwsVo6qyMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/guest/upload/common.vue").then(m => m.default || m)
  },
  {
    name: verifyA7iQg2VfG4Meta?.name ?? "guest-upload-verify",
    path: verifyA7iQg2VfG4Meta?.path ?? "/guest/upload/verify",
    meta: verifyA7iQg2VfG4Meta || {},
    alias: verifyA7iQg2VfG4Meta?.alias || [],
    redirect: verifyA7iQg2VfG4Meta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/guest/upload/verify.vue").then(m => m.default || m)
  },
  {
    name: indexjisZXFHj6YMeta?.name ?? "index",
    path: indexjisZXFHj6YMeta?.path ?? "/",
    meta: indexjisZXFHj6YMeta || {},
    alias: indexjisZXFHj6YMeta?.alias || [],
    redirect: indexjisZXFHj6YMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93sg62w3mQesMeta?.name ?? "mypage-admin-answer-and-evaluation-evaluation-detail-id",
    path: _91id_93sg62w3mQesMeta?.path ?? "/mypage/admin/answer-and-evaluation/evaluation-detail/:id()",
    meta: _91id_93sg62w3mQesMeta || {},
    alias: _91id_93sg62w3mQesMeta?.alias || [],
    redirect: _91id_93sg62w3mQesMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/answer-and-evaluation/evaluation-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93fhpKLDUomGMeta?.name ?? "mypage-admin-answer-and-evaluation-evaluation-detail-buyer-id",
    path: _91id_93fhpKLDUomGMeta?.path ?? "/mypage/admin/answer-and-evaluation/evaluation-detail/buyer/:id()",
    meta: _91id_93fhpKLDUomGMeta || {},
    alias: _91id_93fhpKLDUomGMeta?.alias || [],
    redirect: _91id_93fhpKLDUomGMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/answer-and-evaluation/evaluation-detail/buyer/[id].vue").then(m => m.default || m)
  },
  {
    name: indexvpo1ogwr2eMeta?.name ?? "mypage-admin-answer-and-evaluation",
    path: indexvpo1ogwr2eMeta?.path ?? "/mypage/admin/answer-and-evaluation",
    meta: indexvpo1ogwr2eMeta || {},
    alias: indexvpo1ogwr2eMeta?.alias || [],
    redirect: indexvpo1ogwr2eMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/answer-and-evaluation/index.vue").then(m => m.default || m)
  },
  {
    name: emailWhE3jS3LpbMeta?.name ?? "mypage-admin-buyer-supplierRegistTemplateId-email",
    path: emailWhE3jS3LpbMeta?.path ?? "/mypage/admin/buyer/:supplierRegistTemplateId()/email",
    meta: emailWhE3jS3LpbMeta || {},
    alias: emailWhE3jS3LpbMeta?.alias || [],
    redirect: emailWhE3jS3LpbMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/buyer/[supplierRegistTemplateId]/email.vue").then(m => m.default || m)
  },
  {
    name: indexHWOFN1NaoGMeta?.name ?? "mypage-admin-buyer-supplierRegistTemplateId",
    path: indexHWOFN1NaoGMeta?.path ?? "/mypage/admin/buyer/:supplierRegistTemplateId()",
    meta: indexHWOFN1NaoGMeta || {},
    alias: indexHWOFN1NaoGMeta?.alias || [],
    redirect: indexHWOFN1NaoGMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/buyer/[supplierRegistTemplateId]/index.vue").then(m => m.default || m)
  },
  {
    name: indextXAXIfGeK4Meta?.name ?? "mypage-admin-buyer-supplierRegistTemplateId-new",
    path: indextXAXIfGeK4Meta?.path ?? "/mypage/admin/buyer/:supplierRegistTemplateId()/new",
    meta: indextXAXIfGeK4Meta || {},
    alias: indextXAXIfGeK4Meta?.alias || [],
    redirect: indextXAXIfGeK4Meta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/buyer/[supplierRegistTemplateId]/new/index.vue").then(m => m.default || m)
  },
  {
    name: buyerlisttMOwyoUqQXMeta?.name ?? "mypage-admin-buyerlist",
    path: buyerlisttMOwyoUqQXMeta?.path ?? "/mypage/admin/buyerlist",
    meta: buyerlisttMOwyoUqQXMeta || {},
    alias: buyerlisttMOwyoUqQXMeta?.alias || [],
    redirect: buyerlisttMOwyoUqQXMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/buyerlist.vue").then(m => m.default || m)
  },
  {
    name: indexIHPJc7RTDeMeta?.name ?? "mypage-admin-companies-companyId-users-userId-edit",
    path: indexIHPJc7RTDeMeta?.path ?? "/mypage/admin/companies/:companyId()/users/:userId()/edit",
    meta: indexIHPJc7RTDeMeta || {},
    alias: indexIHPJc7RTDeMeta?.alias || [],
    redirect: indexIHPJc7RTDeMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/companies/[companyId]/users/[userId]/edit/index.vue").then(m => m.default || m)
  },
  {
    name: indexuBpO210oM1Meta?.name ?? "mypage-admin-companies-companyId-users-create",
    path: indexuBpO210oM1Meta?.path ?? "/mypage/admin/companies/:companyId()/users/create",
    meta: indexuBpO210oM1Meta || {},
    alias: indexuBpO210oM1Meta?.alias || [],
    redirect: indexuBpO210oM1Meta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/companies/[companyId]/users/create/index.vue").then(m => m.default || m)
  },
  {
    name: company7lXqIdYItdMeta?.name ?? "mypage-admin-datashare-company",
    path: company7lXqIdYItdMeta?.path ?? "/mypage/admin/datashare/company",
    meta: company7lXqIdYItdMeta || {},
    alias: company7lXqIdYItdMeta?.alias || [],
    redirect: company7lXqIdYItdMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/datashare/company.vue").then(m => m.default || m)
  },
  {
    name: detailgGiBoCAawlMeta?.name ?? "mypage-admin-datashare-detail",
    path: detailgGiBoCAawlMeta?.path ?? "/mypage/admin/datashare/detail",
    meta: detailgGiBoCAawlMeta || {},
    alias: detailgGiBoCAawlMeta?.alias || [],
    redirect: detailgGiBoCAawlMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/datashare/detail.vue").then(m => m.default || m)
  },
  {
    name: indexPd4MOgAIEPMeta?.name ?? "mypage-admin-datashare",
    path: indexPd4MOgAIEPMeta?.path ?? "/mypage/admin/datashare",
    meta: indexPd4MOgAIEPMeta || {},
    alias: indexPd4MOgAIEPMeta?.alias || [],
    redirect: indexPd4MOgAIEPMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/datashare/index.vue").then(m => m.default || m)
  },
  {
    name: entryBmdePYNgOXMeta?.name ?? "mypage-admin-entry",
    path: entryBmdePYNgOXMeta?.path ?? "/mypage/admin/entry",
    meta: entryBmdePYNgOXMeta || {},
    alias: entryBmdePYNgOXMeta?.alias || [],
    redirect: entryBmdePYNgOXMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/entry.vue").then(m => m.default || m)
  },
  {
    name: loginlXXViEg2u4Meta?.name ?? "mypage-admin-login",
    path: loginlXXViEg2u4Meta?.path ?? "/mypage/admin/login",
    meta: loginlXXViEg2u4Meta || {},
    alias: loginlXXViEg2u4Meta?.alias || [],
    redirect: loginlXXViEg2u4Meta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/login.vue").then(m => m.default || m)
  },
  {
    name: editL3VxJyux4cMeta?.name ?? "mypage-admin-questiondetail-id-edit",
    path: editL3VxJyux4cMeta?.path ?? "/mypage/admin/questiondetail/:id()/edit",
    meta: editL3VxJyux4cMeta || {},
    alias: editL3VxJyux4cMeta?.alias || [],
    redirect: editL3VxJyux4cMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/questiondetail/[id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexMloCRhozHxMeta?.name ?? "mypage-admin-questiondetail-id",
    path: indexMloCRhozHxMeta?.path ?? "/mypage/admin/questiondetail/:id()",
    meta: indexMloCRhozHxMeta || {},
    alias: indexMloCRhozHxMeta?.alias || [],
    redirect: indexMloCRhozHxMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/questiondetail/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: questionentryYnGDIpO2gAMeta?.name ?? "mypage-admin-questionentry",
    path: questionentryYnGDIpO2gAMeta?.path ?? "/mypage/admin/questionentry",
    meta: questionentryYnGDIpO2gAMeta || {},
    alias: questionentryYnGDIpO2gAMeta?.alias || [],
    redirect: questionentryYnGDIpO2gAMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/questionentry.vue").then(m => m.default || m)
  },
  {
    name: questionslist2jqNutTamUMeta?.name ?? "mypage-admin-questionslist",
    path: questionslist2jqNutTamUMeta?.path ?? "/mypage/admin/questionslist",
    meta: questionslist2jqNutTamUMeta || {},
    alias: questionslist2jqNutTamUMeta?.alias || [],
    redirect: questionslist2jqNutTamUMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/questionslist.vue").then(m => m.default || m)
  },
  {
    name: index3yTTPaDl1rMeta?.name ?? "mypage-admin-userdetail-companyId",
    path: index3yTTPaDl1rMeta?.path ?? "/mypage/admin/userdetail/:companyId()",
    meta: index3yTTPaDl1rMeta || {},
    alias: index3yTTPaDl1rMeta?.alias || [],
    redirect: index3yTTPaDl1rMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/userdetail/[companyId]/index.vue").then(m => m.default || m)
  },
  {
    name: questionaddI3crPuhzaPMeta?.name ?? "mypage-admin-userdetail-companyId-questionadd",
    path: questionaddI3crPuhzaPMeta?.path ?? "/mypage/admin/userdetail/:companyId()/questionadd",
    meta: questionaddI3crPuhzaPMeta || {},
    alias: questionaddI3crPuhzaPMeta?.alias || [],
    redirect: questionaddI3crPuhzaPMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/userdetail/[companyId]/questionadd.vue").then(m => m.default || m)
  },
  {
    name: _91supplierRegistTemplateId_931VplssFiAxMeta?.name ?? "mypage-admin-userdetail-companyId-report-generation-supplierRegistTemplateId",
    path: _91supplierRegistTemplateId_931VplssFiAxMeta?.path ?? "/mypage/admin/userdetail/:companyId()/report-generation/:supplierRegistTemplateId()",
    meta: _91supplierRegistTemplateId_931VplssFiAxMeta || {},
    alias: _91supplierRegistTemplateId_931VplssFiAxMeta?.alias || [],
    redirect: _91supplierRegistTemplateId_931VplssFiAxMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/userdetail/[companyId]/report-generation/[supplierRegistTemplateId].vue").then(m => m.default || m)
  },
  {
    name: _91id_93N8soJ11dKAMeta?.name ?? "mypage-admin-useredit-id",
    path: _91id_93N8soJ11dKAMeta?.path ?? "/mypage/admin/useredit/:id()",
    meta: _91id_93N8soJ11dKAMeta || {},
    alias: _91id_93N8soJ11dKAMeta?.alias || [],
    redirect: _91id_93N8soJ11dKAMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/useredit/[id].vue").then(m => m.default || m)
  },
  {
    name: userlisthZAhp2PCWIMeta?.name ?? "mypage-admin-userlist",
    path: userlisthZAhp2PCWIMeta?.path ?? "/mypage/admin/userlist",
    meta: userlisthZAhp2PCWIMeta || {},
    alias: userlisthZAhp2PCWIMeta?.alias || [],
    redirect: userlisthZAhp2PCWIMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/admin/userlist.vue").then(m => m.default || m)
  },
  {
    name: detailR6Ozkw0i7wMeta?.name ?? "mypage-buyer-datashare-detail",
    path: detailR6Ozkw0i7wMeta?.path ?? "/mypage/buyer/datashare/detail",
    meta: detailR6Ozkw0i7wMeta || {},
    alias: detailR6Ozkw0i7wMeta?.alias || [],
    redirect: detailR6Ozkw0i7wMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/buyer/datashare/detail.vue").then(m => m.default || m)
  },
  {
    name: indexBVZv1d3LtcMeta?.name ?? "mypage-buyer-datashare",
    path: indexBVZv1d3LtcMeta?.path ?? "/mypage/buyer/datashare",
    meta: indexBVZv1d3LtcMeta || {},
    alias: indexBVZv1d3LtcMeta?.alias || [],
    redirect: indexBVZv1d3LtcMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/buyer/datashare/index.vue").then(m => m.default || m)
  },
  {
    name: contactX4ulMiyUnSMeta?.name ?? "mypage-contact",
    path: contactX4ulMiyUnSMeta?.path ?? "/mypage/contact",
    meta: contactX4ulMiyUnSMeta || {},
    alias: contactX4ulMiyUnSMeta?.alias || [],
    redirect: contactX4ulMiyUnSMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/contact.vue").then(m => m.default || m)
  },
  {
    name: dashboard5QndT6N0f0Meta?.name ?? "mypage-dashboard",
    path: dashboard5QndT6N0f0Meta?.path ?? "/mypage/dashboard",
    meta: dashboard5QndT6N0f0Meta || {},
    alias: dashboard5QndT6N0f0Meta?.alias || [],
    redirect: dashboard5QndT6N0f0Meta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/dashboard.vue").then(m => m.default || m)
  },
  {
    name: companyRTDT9wWDdAMeta?.name ?? "mypage-datashare-company",
    path: companyRTDT9wWDdAMeta?.path ?? "/mypage/datashare/company",
    meta: companyRTDT9wWDdAMeta || {},
    alias: companyRTDT9wWDdAMeta?.alias || [],
    redirect: companyRTDT9wWDdAMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/datashare/company.vue").then(m => m.default || m)
  },
  {
    name: detail0o8xIFkaBtMeta?.name ?? "mypage-datashare-detail",
    path: detail0o8xIFkaBtMeta?.path ?? "/mypage/datashare/detail",
    meta: detail0o8xIFkaBtMeta || {},
    alias: detail0o8xIFkaBtMeta?.alias || [],
    redirect: detail0o8xIFkaBtMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/datashare/detail.vue").then(m => m.default || m)
  },
  {
    name: edituOarTdcl0nMeta?.name ?? "mypage-datashare-edit",
    path: edituOarTdcl0nMeta?.path ?? "/mypage/datashare/edit",
    meta: edituOarTdcl0nMeta || {},
    alias: edituOarTdcl0nMeta?.alias || [],
    redirect: edituOarTdcl0nMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/datashare/edit.vue").then(m => m.default || m)
  },
  {
    name: indexSgQft1jPa9Meta?.name ?? "mypage-datashare",
    path: indexSgQft1jPa9Meta?.path ?? "/mypage/datashare",
    meta: indexSgQft1jPa9Meta || {},
    alias: indexSgQft1jPa9Meta?.alias || [],
    redirect: indexSgQft1jPa9Meta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/datashare/index.vue").then(m => m.default || m)
  },
  {
    name: detail_45extraBXEjtaeRdZMeta?.name ?? "mypage-detail-extra",
    path: detail_45extraBXEjtaeRdZMeta?.path ?? "/mypage/detail-extra",
    meta: detail_45extraBXEjtaeRdZMeta || {},
    alias: detail_45extraBXEjtaeRdZMeta?.alias || [],
    redirect: detail_45extraBXEjtaeRdZMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/detail-extra.vue").then(m => m.default || m)
  },
  {
    name: indexsnxNXnK5LUMeta?.name ?? "mypage-evaluation-analysis",
    path: indexsnxNXnK5LUMeta?.path ?? "/mypage/evaluation/analysis",
    meta: indexsnxNXnK5LUMeta || {},
    alias: indexsnxNXnK5LUMeta?.alias || [],
    redirect: indexsnxNXnK5LUMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/evaluation/analysis/index.vue").then(m => m.default || m)
  },
  {
    name: indexVFaGcXljeWMeta?.name ?? "mypage-evaluation-dashboard",
    path: indexVFaGcXljeWMeta?.path ?? "/mypage/evaluation/dashboard",
    meta: indexVFaGcXljeWMeta || {},
    alias: indexVFaGcXljeWMeta?.alias || [],
    redirect: indexVFaGcXljeWMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/evaluation/dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: improvementplans0mh4yrrefeMeta?.name ?? "mypage-evaluation-improvementplans",
    path: improvementplans0mh4yrrefeMeta?.path ?? "/mypage/evaluation/improvementplans",
    meta: improvementplans0mh4yrrefeMeta || {},
    alias: improvementplans0mh4yrrefeMeta?.alias || [],
    redirect: improvementplans0mh4yrrefeMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/evaluation/improvementplans.vue").then(m => m.default || m)
  },
  {
    name: detailmAM62vEyFaMeta?.name ?? "mypage-improvementplans-detail",
    path: detailmAM62vEyFaMeta?.path ?? "/mypage/improvementplans/detail",
    meta: detailmAM62vEyFaMeta || {},
    alias: detailmAM62vEyFaMeta?.alias || [],
    redirect: detailmAM62vEyFaMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/improvementplans/detail.vue").then(m => m.default || m)
  },
  {
    name: indexN1KpmlY7cQMeta?.name ?? "mypage-improvementplans",
    path: indexN1KpmlY7cQMeta?.path ?? "/mypage/improvementplans",
    meta: indexN1KpmlY7cQMeta || {},
    alias: indexN1KpmlY7cQMeta?.alias || [],
    redirect: indexN1KpmlY7cQMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/improvementplans/index.vue").then(m => m.default || m)
  },
  {
    name: login_45mfaA63ZaRc9mvMeta?.name ?? "mypage-login-mfa",
    path: login_45mfaA63ZaRc9mvMeta?.path ?? "/mypage/login-mfa",
    meta: login_45mfaA63ZaRc9mvMeta || {},
    alias: login_45mfaA63ZaRc9mvMeta?.alias || [],
    redirect: login_45mfaA63ZaRc9mvMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/login-mfa.vue").then(m => m.default || m)
  },
  {
    name: loginiiF0XlPWIZMeta?.name ?? "mypage-login",
    path: loginiiF0XlPWIZMeta?.path ?? "/mypage/login",
    meta: loginiiF0XlPWIZMeta || {},
    alias: loginiiF0XlPWIZMeta?.alias || [],
    redirect: loginiiF0XlPWIZMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/login.vue").then(m => m.default || m)
  },
  {
    name: logout5VnaPrLLoqMeta?.name ?? "mypage-logout",
    path: logout5VnaPrLLoqMeta?.path ?? "/mypage/logout",
    meta: logout5VnaPrLLoqMeta || {},
    alias: logout5VnaPrLLoqMeta?.alias || [],
    redirect: logout5VnaPrLLoqMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/logout.vue").then(m => m.default || m)
  },
  {
    name: confirmwVacYnUyOKMeta?.name ?? "mypage-question-groups-questionGroupId-confirm",
    path: confirmwVacYnUyOKMeta?.path ?? "/mypage/question-groups/:questionGroupId()/confirm",
    meta: confirmwVacYnUyOKMeta || {},
    alias: confirmwVacYnUyOKMeta?.alias || [],
    redirect: confirmwVacYnUyOKMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/[questionGroupId]/confirm.vue").then(m => m.default || m)
  },
  {
    name: edit0oTqwFY0NJMeta?.name ?? "mypage-question-groups-questionGroupId-edit",
    path: edit0oTqwFY0NJMeta?.path ?? "/mypage/question-groups/:questionGroupId()/edit",
    meta: edit0oTqwFY0NJMeta || {},
    alias: edit0oTqwFY0NJMeta?.alias || [],
    redirect: edit0oTqwFY0NJMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/[questionGroupId]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexjGGOhGFtNGMeta?.name ?? "mypage-question-groups-questionGroupId",
    path: indexjGGOhGFtNGMeta?.path ?? "/mypage/question-groups/:questionGroupId()",
    meta: indexjGGOhGFtNGMeta || {},
    alias: indexjGGOhGFtNGMeta?.alias || [],
    redirect: indexjGGOhGFtNGMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/[questionGroupId]/index.vue").then(m => m.default || m)
  },
  {
    name: previewWr1Nm9W4F8Meta?.name ?? "mypage-question-groups-questionGroupId-preview",
    path: previewWr1Nm9W4F8Meta?.path ?? "/mypage/question-groups/:questionGroupId()/preview",
    meta: previewWr1Nm9W4F8Meta || {},
    alias: previewWr1Nm9W4F8Meta?.alias || [],
    redirect: previewWr1Nm9W4F8Meta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/[questionGroupId]/preview.vue").then(m => m.default || m)
  },
  {
    name: _91questionGroupByCompanyId_93iHvKqRPBTAMeta?.name ?? "mypage-question-groups-answers-questionGroupByCompanyId",
    path: _91questionGroupByCompanyId_93iHvKqRPBTAMeta?.path ?? "/mypage/question-groups/answers/:questionGroupByCompanyId()",
    meta: _91questionGroupByCompanyId_93iHvKqRPBTAMeta || {},
    alias: _91questionGroupByCompanyId_93iHvKqRPBTAMeta?.alias || [],
    redirect: _91questionGroupByCompanyId_93iHvKqRPBTAMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/answers/[questionGroupByCompanyId].vue").then(m => m.default || m)
  },
  {
    name: indexW2QpscD80JMeta?.name ?? "mypage-question-groups-answers",
    path: indexW2QpscD80JMeta?.path ?? "/mypage/question-groups/answers",
    meta: indexW2QpscD80JMeta || {},
    alias: indexW2QpscD80JMeta?.alias || [],
    redirect: indexW2QpscD80JMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/answers/index.vue").then(m => m.default || m)
  },
  {
    name: indexpiA3aoTNKYMeta?.name ?? "mypage-question-groups",
    path: indexpiA3aoTNKYMeta?.path ?? "/mypage/question-groups",
    meta: indexpiA3aoTNKYMeta || {},
    alias: indexpiA3aoTNKYMeta?.alias || [],
    redirect: indexpiA3aoTNKYMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/index.vue").then(m => m.default || m)
  },
  {
    name: newbN2uwnH2AHMeta?.name ?? "mypage-question-groups-new",
    path: newbN2uwnH2AHMeta?.path ?? "/mypage/question-groups/new",
    meta: newbN2uwnH2AHMeta || {},
    alias: newbN2uwnH2AHMeta?.alias || [],
    redirect: newbN2uwnH2AHMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/question-groups/new.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordz0Bq4hrpekMeta?.name ?? "mypage-resetpassword",
    path: resetpasswordz0Bq4hrpekMeta?.path ?? "/mypage/resetpassword",
    meta: resetpasswordz0Bq4hrpekMeta || {},
    alias: resetpasswordz0Bq4hrpekMeta?.alias || [],
    redirect: resetpasswordz0Bq4hrpekMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/resetpassword.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordcompleteWccBJH9gcVMeta?.name ?? "mypage-resetpasswordcomplete",
    path: resetpasswordcompleteWccBJH9gcVMeta?.path ?? "/mypage/resetpasswordcomplete",
    meta: resetpasswordcompleteWccBJH9gcVMeta || {},
    alias: resetpasswordcompleteWccBJH9gcVMeta?.alias || [],
    redirect: resetpasswordcompleteWccBJH9gcVMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/resetpasswordcomplete.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordconfirm49Um8cJnRIMeta?.name ?? "mypage-resetpasswordconfirm",
    path: resetpasswordconfirm49Um8cJnRIMeta?.path ?? "/mypage/resetpasswordconfirm",
    meta: resetpasswordconfirm49Um8cJnRIMeta || {},
    alias: resetpasswordconfirm49Um8cJnRIMeta?.alias || [],
    redirect: resetpasswordconfirm49Um8cJnRIMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/resetpasswordconfirm.vue").then(m => m.default || m)
  },
  {
    name: index1nPrZSA9dtMeta?.name ?? "mypage-scorecard-detail",
    path: index1nPrZSA9dtMeta?.path ?? "/mypage/scorecard/detail",
    meta: index1nPrZSA9dtMeta || {},
    alias: index1nPrZSA9dtMeta?.alias || [],
    redirect: index1nPrZSA9dtMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/scorecard/detail/index.vue").then(m => m.default || m)
  },
  {
    name: preview7PyavizkuPMeta?.name ?? "mypage-scorecard-detail-preview",
    path: preview7PyavizkuPMeta?.path ?? "/mypage/scorecard/detail/preview",
    meta: preview7PyavizkuPMeta || {},
    alias: preview7PyavizkuPMeta?.alias || [],
    redirect: preview7PyavizkuPMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/scorecard/detail/preview.vue").then(m => m.default || m)
  },
  {
    name: indexdG9WooZRu9Meta?.name ?? "mypage-scorecard",
    path: indexdG9WooZRu9Meta?.path ?? "/mypage/scorecard",
    meta: indexdG9WooZRu9Meta || {},
    alias: indexdG9WooZRu9Meta?.alias || [],
    redirect: indexdG9WooZRu9Meta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/scorecard/index.vue").then(m => m.default || m)
  },
  {
    name: indexH2FrSDJUAOMeta?.name ?? "mypage-settings-account-userId-edit",
    path: indexH2FrSDJUAOMeta?.path ?? "/mypage/settings/account/:userId()/edit",
    meta: indexH2FrSDJUAOMeta || {},
    alias: indexH2FrSDJUAOMeta?.alias || [],
    redirect: indexH2FrSDJUAOMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/settings/account/[userId]/edit/index.vue").then(m => m.default || m)
  },
  {
    name: indexSN8nPRRcvzMeta?.name ?? "mypage-settings-account-create",
    path: indexSN8nPRRcvzMeta?.path ?? "/mypage/settings/account/create",
    meta: indexSN8nPRRcvzMeta || {},
    alias: indexSN8nPRRcvzMeta?.alias || [],
    redirect: indexSN8nPRRcvzMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/settings/account/create/index.vue").then(m => m.default || m)
  },
  {
    name: indexN5UnQqZ3GeMeta?.name ?? "mypage-settings-account",
    path: indexN5UnQqZ3GeMeta?.path ?? "/mypage/settings/account",
    meta: indexN5UnQqZ3GeMeta || {},
    alias: indexN5UnQqZ3GeMeta?.alias || [],
    redirect: indexN5UnQqZ3GeMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/settings/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexY9EM8rOKRkMeta?.name ?? "mypage-upload-common",
    path: indexY9EM8rOKRkMeta?.path ?? "/mypage/upload/common",
    meta: indexY9EM8rOKRkMeta || {},
    alias: indexY9EM8rOKRkMeta?.alias || [],
    redirect: indexY9EM8rOKRkMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/mypage/upload/common/index.vue").then(m => m.default || m)
  },
  {
    name: _91temporaryUserId_93dgjgx8lbvaMeta?.name ?? "supplier-register-supplierRegistTemplateId-temporaryUserId",
    path: _91temporaryUserId_93dgjgx8lbvaMeta?.path ?? "/supplier/register/:supplierRegistTemplateId()/:temporaryUserId()",
    meta: _91temporaryUserId_93dgjgx8lbvaMeta || {},
    alias: _91temporaryUserId_93dgjgx8lbvaMeta?.alias || [],
    redirect: _91temporaryUserId_93dgjgx8lbvaMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/supplier/register/[supplierRegistTemplateId]/[temporaryUserId].vue").then(m => m.default || m)
  },
  {
    name: index2Nbb5vFbHzMeta?.name ?? "supplier-register-supplierRegistTemplateId",
    path: index2Nbb5vFbHzMeta?.path ?? "/supplier/register/:supplierRegistTemplateId()",
    meta: index2Nbb5vFbHzMeta || {},
    alias: index2Nbb5vFbHzMeta?.alias || [],
    redirect: index2Nbb5vFbHzMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/supplier/register/[supplierRegistTemplateId]/index.vue").then(m => m.default || m)
  },
  {
    name: index3aPxrNDkCfMeta?.name ?? "users-create-userId",
    path: index3aPxrNDkCfMeta?.path ?? "/users/create/:userId()",
    meta: index3aPxrNDkCfMeta || {},
    alias: index3aPxrNDkCfMeta?.alias || [],
    redirect: index3aPxrNDkCfMeta?.redirect || undefined,
    component: () => import("/home/runner/work/sustaina-rating-front/sustaina-rating-front/apps/web/pages/users/create/[userId]/index.vue").then(m => m.default || m)
  }
]